<template>
  <div>
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>

    <el-tabs v-model="requestForm.typeId">
      <el-tab-pane label="按照分数试算合格分数线" name="1"></el-tab-pane>
      <el-tab-pane label="按照合格率试算合格分数线" name="2"></el-tab-pane>
    </el-tabs>

    <ots-refer v-bind='$attrs' v-on='$listeners' :selectList="selectList" :requestForm='requestForm'></ots-refer>

    <!--  v-if="requestForm.courseIds" -->
    <!-- <div class="inputList">
      <div class="Number_Of_Examinees title">应考人数：<span style="color: #909399;">{{shouldCount}}</span></div>
      <div class="Number_Of_Examinees title">实考人数：<span style="color: #67c23a;">{{examCount}}</span></div>
    </div> -->

    <div class="inputList">
        <div class="redTitle">{{requestForm.typeId == '1' ? '说明：如需要对综合科目下的单科分别设置分数线进行试算，请导入试算分数模板': '说明：合格率试算不支持综合科目下的单科合格率设置'}}</div>
        <div class="title">{{requestForm.typeId == '1' ? '合格分数线设置': '合格率设置'}}</div>
        <div class="ipScope">
          <div v-for="(item, index) in LineList" :key="index" class="inputBox">
            <el-input v-model="item.score" placeholder="大于等于"></el-input>
            <span>{{requestForm.typeId == '1' ? '分' : '%'}}</span>
            <i v-if="index !== 0" class="el-icon-delete" @click="deletScore(index)"></i>
          </div>
          <div class="buttons">
            <el-button type="primary" round @click="addScore">+ 增加</el-button>
            <el-button type="primary" round plain style="margin-left: 36px;" @click="qualified_Personnel(1)">{{requestForm.typeId == '1' ? '按照实考人数试算合格人数占比': '按照实考人数试算合格分数线'}}</el-button>
            <el-button type="primary" round plain style="margin-left: 36px;" @click="qualified_Personnel(2)">{{requestForm.typeId == '1' ? '按照应考人数试算合格人数占比': '按照应考人数试算合格分数线'}}</el-button>
            <el-button type="primary" round plain style="margin-left: 36px;" @click="qualified_Personnel(3)">{{requestForm.typeId == '1' ? '按照报名范围试算合格人数占比': '按照报名范围试算合格分数线'}}</el-button>
          </div>
        </div>
    </div>

    <div class="mainCon">
      <div class="ots-table" style="position: relative;">


       <el-table :data="tableData" style="width: 100%" >
        
        <el-table-column
          :prop="item.prop"
          :label="item.title"
          align="center"
          v-for="(item,index) in tableHeader"
          :key="index"
        >
          <template slot-scope="scope">
            <span class="table-text" v-html="getTableText(item, scope)">
            </span>
          </template>
        </el-table-column>

        <el-table-column :label="item.title" v-for="(item,index) in tableHeader_Score" :key="index.title" align="center">
          <el-table-column
            v-for="(v,i) in item.headerList"
            :key="i"
            :prop="`sections[${index}][${v.prop}]`"
            :label="v.title"
            align="center"
          >
            <template slot-scope="scope">
              <span class="table-text" v-html="getTableText_Score(v, scope, index)">
              </span>
            </template>
          </el-table-column>
        </el-table-column>

        <!-- <el-table-column label="查看分布图" align="center">
          <template slot-scope="scope">
            <span class="table-text" style="color: #006AFF; cursor: pointer;" @click="showGreade(scope.row)">
              查看
            </span>
          </template>
        </el-table-column> -->


      </el-table>       


        <!-- <el-table ref="el-table" :data="tableData" style="width: 100%;" @cell-mouse-enter="mouseEnter" :cell-style="cellStyle" @cell-mouse-leave="mouseLeave">
          <template v-for="(item, index) in tableHeader">
            <el-table-column :key="index" :label="item.title" v-bind="setAttribute(item, index)">
              <template slot-scope="scope">
                <span class="table-text" v-html="getTableText(item, scope)" @click="getTableText(item, scope)"></span>
              </template>
            </el-table-column>

          </template>
        </el-table> -->





        <p class="msg" v-show="isShowMsg" id="msg" @mouseleave="mouseLeave">{{msg}}</p>
      </div>

    </div>

    <!-- 弹窗 -->
    <ots-custom-dialog :dialog.sync="importData.importExcelDialogFlag" title="导入试算分数" width="40%">
      <template v-slot:content>
        <div class="exportDialog">
          <el-form>
            <el-form-item label="1.选择考试批次" class="mb20">
              <el-select v-model="importData.planId" filterable clearable placeholder="请选择">
                <el-option v-for="item in importData.planInfoList" :key="item.planId" :label="item.planName" :value="item.planId"></el-option>
              </el-select>
            </el-form-item>
            <p style="margin-bottom: 8px;">2.模板下载</p>
            <el-form-item>
              <i class="el-icon-download"></i>
              <el-link type="primary" @click="downloadTemplate">下载试算分数导入模板</el-link>
            </el-form-item>
            <el-form-item label="3.导入文件" v-model="importData.file">
              <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
            </el-form-item>
          </el-form>
          <div class="impExplain">
            <span class="tipTitle"><i></i>提示：</span>
            <div>
              <div>1:模板中<span class="col_red">*</span>字段为必填项</div>
              <div>2:只能上传扩展名为<span class="col_red">.xlsx</span>的文件</div>
              <div>3:导入后查看试算结果请到消息中心查看</div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="importData.importExcelDialogFlag = false">取消</el-button>
        <el-button round type="primary" @click="importExcelFn">导入</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>
<script>
import { getTrialScoreLinePlanListApi, getCourseListApi, getTrialScoreLineListApi, getExamNumByCourseAPI, getTrialScoreLineExportAPI,downloadTrialFileAPI,uploadTrialFileAPI } from "@/http/modules/examSet/score";
export default {
  name: 'ots-refer-search',
  data () {
    return {
      activeName: 'second',
      selectList: [
        {
          title: "批次名称",
          type: "select",
          requestKey: "planId",
          label: "planName",
          value: "planId",
          isSearch: true,
          data: [],
        },
        {
          title:'课程名称',
          type: "select",
          requestKey:'courseIds',
          label: "courseName",
          value: "courseId",
          multiple: true,
          data: [],
        }
      ],
      requestForm: {
        planId: '',
        courseIds: [""],
        typeId: '1',
        scopeFlag: '1',
      },
      LineList: [
        { score: 0 },
      ],
      tableHeader: [
        {
          title: "课程名称",
          prop: "courseName",
        },
        {
          title: "报名范围",
          prop: "signedCount",
        },
        {
          title: "应考人数",
          prop: "shouldExamCount",
        },
        {
          title: "实考人数",
          prop: "examedCount",
        },
        // {
        //   title: "合格人数占比",
        //   prop: "passPercent",
        //   formatter: (scope) => {
        //     return scope.row.passPercent + "%";
        //   }
        // }
      ],
      importData:{
        planId: '',
        file: '',
        planInfoList: [],
        importExcelDialogFlag : false,
      },
      tableHeader_Score: [],
      tableData: [],
      // shouldCount: '',
      // examCount: '',
      msg: '',
      isShowMsg: false,

      mainTopBtnList: [
        {
          title: "导入试算分数",
          fn: this.importExcelDialog,
        },
        {
          title: "导出",
          fn: this.exportExcel,
        },
      ],
    }
  },

  watch: {
    "requestForm.planId": "getCourseList",
    "requestForm.typeId": "resetAllData",
    "requestForm.courseIds": "getExamNumber",
  },

  computed: {
   useQualified_Personnel() {
     const Reg = /^\d+(\.\d{1,2})?$/;
     return Object.values(this.LineList).every(
      (line) => line.score === "" || Reg.test(Number(line.score))
     );
   }
  },

  mounted() {
    this.getOverPlanList();
  },

  methods: {
    importExcelDialog(){
      this.importData.importExcelDialogFlag = true;
    },
    async downloadTemplate(){
      let { code,data } = await downloadTrialFileAPI({ planId : this.importData.planId });
      if(code == 1){
        window.open(data);
      }
    },
    handleFormData(val) {
      this.importData.file = val.file;
    },
    async importExcelFn(){
      if (!this.importData.file) {
        this.$message.error("请选择文件");
        return;
      }
      const params = new FormData();
      params.append('planId', this.importData.planId);
      params.append('file', this.importData.file);
      //const { code, data } = await uploadTrialFileAPI(params)
      //if (code == 1) {
      //  this.$message.success(data);
      //  this.importData.importExcelDialogFlag = false;
      //}      
      uploadTrialFileAPI(params).then((res) => {
        if (res.code) {
          this.importData.importExcelDialogFlag = false;
          const failNum = res.data.errorCount ? parseInt(res.data.errorCount) : 0;
          const successNum = res.data.successCount ? parseInt(res.data.successCount) : 0;
          const returnMsg = res.data.message;
          const message = failNum > 0 ? `导入失败，里面有${failNum}条错误数据，请修复后重新上传` : returnMsg ;
          const confirmBtnText =  failNum > 0 ? "查看错误记录" : "确定" ;
          this.$confirm(message, "导入结果", {
            confirmButtonText: confirmBtnText,
            cancelButtonText: "取消",
            type: failNum > 0 ? "warning" : "success",
          }).then(() => {
            if (failNum > 0) {
              window.location.href = res.data.fileUrl;
            }
          });
        }
      });
    },
    async exportExcel() {
      if (!this.useQualified_Personnel) {
        this.$message.error(`${this.requestForm.typeId == 1 ? '合格分数线': '合格率'}设置有误，请修改后重试！`);
        return;
      }

      if (!this.requestForm.courseIds) {
        this.$message.warning("请选择课程！");
        return;
      }

      let passScore = this.LineList.map(e=>{
        return e.score
      })

      const uniquepassScore = new Set(passScore.map(item => item));
      const ScoreFlag = passScore.length !== uniquepassScore.size;
      if (ScoreFlag) {
        this.$message.warning(`请勿重复录入${this.requestForm.typeId == 1 ? '合格分数线': '合格率'}！`);
        return;
      }
      
      passScore = passScore.filter(item => item !== "");
      passScore.sort(function(a, b) {return a - b})
      passScore = passScore.join(",");
      let param = { ...this.requestForm, passScore }
      let courseIds = this.requestForm.courseIds.join();
      param.courseIds = courseIds == '-1' ? '': courseIds;
      const { code, data } = await getTrialScoreLineExportAPI(param);
      if (code == 1) {
        window.open(data);
      }
    },
    
    cellStyle(row) {
      if (row.row.msg) {
        return 'color: #f56c6c;'
      }
    },
    mouseEnter(row) {
      if (row.msg) {
        this.msg = row.msg;
        this.isShowMsg = true;
      }
    },
    
    mouseLeave(row) {
      this.msg = '';
      this.isShowMsg = false;
    },

    resetAllData(typeId) {
      this.tableData = [];
      this.LineList = [{ score: 0 }];
      this.qualified_Personnel(typeId);

      // return;
      // let item_1, item_2;
      // if (typeId == '1') {
      //   item_1 = {
      //     title: "分数线",
      //     prop: "passScore",
      //   }
      //   item_2 = {
      //     title: "合格人数占比",
      //     prop: "passPercent",
      //     formatter: (scope) => {
      //       return scope.row.passPercent + "%";
      //     }
      //   }
      // } else {
      //   item_1 = {
      //     title: "合格率",
      //     prop: "passPercent",
      //     formatter: (scope) => {
      //       return scope.row.passPercent + "%";
      //     }
      //   }
      //   item_2 = {
      //     title: "合格分数线",
      //     prop: "passScore",
      //   }
      // }
      // this.tableHeader[0] = item_1;
      // this.tableHeader[3] = item_2;
    },

    async getExamNumber(newVal, oldVal) {
      function areArraysEqual(arr1, arr2) {
        return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
      }
      if (areArraysEqual(newVal, oldVal)) {
        return false;
      }
      let newCourseList = newVal.filter(item => item !== "-1");
      const difference = newVal.filter(element => !oldVal.includes(element));
      if (difference[0] == "-1") {
        newCourseList = ["-1"];
      }
      if (newVal.length > 1) {
        this.requestForm.courseIds = newCourseList;
      }
      if (newCourseList.length == this.courseList.length) {
        this.requestForm.courseIds = ["-1"];
      }
    },

    addScore() {
      if (this.LineList.length === 15) {
        this.$message.error(`${this.requestForm.typeId == 1 ? '合格线': '合格率'} 最多允许添加15条！`);
      } else {
        let item = { score: "" };
        this.LineList.push(item);
      }
    },

    deletScore(index) {
      this.LineList.splice(index, 1);
    },

    async qualified_Personnel(flag) {
      this.requestForm.scopeFlag = flag;
      if (!this.useQualified_Personnel) {
        this.$message.error(`${this.requestForm.typeId == 1 ? '合格分数线': '合格率'}设置有误，请修改后重试！`);
        return;
      }
      
      if (!this.requestForm.courseIds) {
        this.$message.warning("请选择课程！");
        return;
      }

      let passScore = this.LineList.map(e=>{
        return e.score
      })

      const uniquepassScore = new Set(passScore.map(item => item));
      const ScoreFlag = passScore.length !== uniquepassScore.size;
      if (ScoreFlag) {
        this.$message.warning(`请勿重复录入${this.requestForm.typeId == 1 ? '合格分数线': '合格率'}！`);
        return;
      }
      
      passScore = passScore.filter(item => item !== "");
      passScore.sort(function(a, b) {return a - b})
      let newPassScore = passScore;
      passScore = passScore.join(",");
      let param = { ...this.requestForm, passScore }

      let courseIds = this.requestForm.courseIds.join();
      param.courseIds = courseIds == '-1' ? '': courseIds;

      const { data: tableData } = await getTrialScoreLineListApi(param);
      this.tableData = tableData;
      this.tableHeader_Score = [];
      let FlagToTitle = flag == 1 ? "（占实考人数）" : flag == 2 ? "（占应考人数）" : "（占报名范围）";

      newPassScore.map(e => {
        let item = {
          title: this.requestForm.typeId == 1 ? e + "分以上" : "合格率" + e + "%" + FlagToTitle,
          headerList: [
            {
              title: "人数",
              prop: "sectionCount"
            },
            {
              title: this.requestForm.typeId == 1 ? "通过率%" + FlagToTitle: "合格分数线",
              prop: this.requestForm.typeId == 1 ? "sectionPercent": "sectionPassScore"
            },
          ]
        }
        this.tableHeader_Score.push(item);
      })
    },

    async getCourseList(planId) {
      const { data: courseList } = await getCourseListApi({planId});
      this.courseList = courseList;
      this.selectList[1].data = [{courseId: "-1", courseName: "全部"}, ...courseList];
      this.requestForm.courseIds = ["-1"];
    },

    async getOverPlanList() {
      const { data: planList } = await getTrialScoreLinePlanListApi({flag: 1});
      this.selectList[0].data = planList;
      this.requestForm.planId = planList[0].planId;
      this.importData.planInfoList = planList;
      this.importData.planId = planList[0].planId;
    },

    setAttribute(item, index) {
      let maxIndex = this.tableHeader.length - 1;
      let headerAlign = "";
      let align
      if (index === 0) {
        headerAlign = "left";
        align = "left";
      } else if (index === maxIndex) {
        headerAlign = "right";
        align = "right";
      } else if (item.type == 'buttons') {
        headerAlign = "right";
        align = "right";
      } else {
        headerAlign = item.headerAlign || "center";
        align = item.align || "center";
      }        
      return {
        headerAlign,
        prop: item.prop,
        fixed: item.fixed,
        label: item.title,
        width: item.width || "auto",
        align
      };
    },
    getTableText(item, scope) {
      let text = item.formatter ? item.formatter(scope) : scope.row[item.prop]
      if (text === "Invalid date") {
        return "-"
      } else {
        return text || text == "0" ? text : "-"
      }
    },
    getTableText_Score(item, scope, index) {
      let text = scope.row.sections[index][item.prop];
      return text || text == "0" ? text : "-";
    },
  }
}
</script>
<style scoped lang="less">
/deep/ .el-button.query-btn{
  display: none;
}

.msg {
  width: 100%; 
  height: 48px; 
  background: #fdf6ec;
  color: #f56c6c;
  position: absolute; 
  top: 0px;
  box-sizing: border-box;
  text-align: center;
  line-height: 48px;
  border: 1px solid #f56c6c;
  border-radius: 4px;
  font-family: "PingFangSC-Medium, PingFang SC";
  transition: all .3s;
}

.inputList {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  margin-top: 16px;
  border: 1px solid transparent;
  box-sizing: border-box;
  font-family: "PingFangSC-Medium, PingFang SC";
}
.redTitle {
  font-size: 14px;
  color: #FE2918;
  font-weight: 500;
  margin-top: 20px;
  padding-left: 24px;
  box-sizing: border-box;
}
.title {
  font-size: 14px;
  color: #626673;
  font-weight: 500;
  margin-top: 20px;
  padding-left: 24px;
  box-sizing: border-box;
}

.Number_Of_Examinees {
  margin-bottom: 16px;
  display: inline-block;
  margin-right: 16px;
}

.ipScope {
  // margin-top: 16px;
  margin-left: 24px;
  width: 380px;
  padding: 24px 32px;
  box-sizing: border-box;
  border-radius: 8px;
  .buttons {
    display: flex;
    justify-content: left;
    margin-top: 24px;
  }
  h6 {
    color: #45494d;
    font-size: 14px;
    margin-bottom: 16px;
  }
  .inputBox {
    display: flex;
    height: 36px;
    line-height: 36px;
    justify-items: center;
    vertical-align: middle;
    margin-bottom: 8px;
    /deep/ .el-input {
      width: 200px;
      height: 36px;
      line-height: 36px;
    }
    span {
      margin: 0 11px;
      color: #626673;
    }
    i {
      margin: 12px 0 0 20px;
      color: #006aff;
    }
  }
  /deep/ .el-radio-button__inner {
    margin-right: 8px;
    color: #45494d !important;
    background: #f4f5f8 !important;
    font-size: 13px;
    border-radius: 4px !important;
    border: 1px solid #dadde6 !important;
    padding: 10px 20px;
  }
  /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #ebf5ff !important;
    border: 1px solid #006aff !important;
    color: #006aff !important;
    box-shadow: none;
  }

  /deep/ .el-checkbox-button__inner {
    margin-right: 8px;
  }

  /deep/ .el-input .el-input__inner {
    width: 200px;
    height: 36px;
    line-height: 18px;
  }

}
.exportDialog {
  .impExplain {
    color: #9299a6;
    // display: flex;
    .tipTitle {
      flex-shrink: 0;
      display: block;
      margin-bottom: 5px;
    }
    div {
      line-height: 30px;
      margin-left: 5px;
    }
  }
}
/deep/ .el-icon-download{
  margin-left:5px;
  color:#006aff;
  font-size: 17px;
}
/deep/ .el-link--inner{
  margin:-5px 0px 0px 1px;
}
</style>